import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { AuthService } from "../../auth/auth.service";
import type { GeminiConversation } from "./gemini-chat.interface";

@Injectable({ providedIn: "root" })
export class GeminiChatService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) {}

  chat(
    prompt: string,
    userPrompt: string,
    templateId?: string,
    initialContent?: string,
  ): Observable<string> {
    return this.http
      .post<{ html: string }>("/gemini/chat", {
        prompt,
        userPrompt,
        domain: this.authService.currentDomain,
        email: this.authService.appUser?.email,
        templateId,
        initialContent,
      })
      .pipe(map((res) => res.html));
  }

  getHistory(templateId: string): Observable<GeminiConversation | null> {
    return this.http
      .get<{
        conversation: GeminiConversation | null;
      }>(
        `/gemini/history/${templateId}?domain=${this.authService.currentDomain}&email=${this.authService.appUser?.email || ""}`,
      )
      .pipe(map((res) => res.conversation));
  }

  updateConversationTemplateId(
    oldTemplateId: string,
    newTemplateId: string,
  ): Observable<void> {
    return this.http
      .put<{ success: boolean }>(`/gemini/history/update-template-id`, {
        oldTemplateId,
        newTemplateId,
        domain: this.authService.currentDomain,
        email: this.authService.appUser?.email || "",
      })
      .pipe(map((): void => void 0));
  }
}
